import { Model, SurveyModel } from 'survey-core';

// MET-454: on the application form the licensing attestation must read
// "... AS REQUIRED ..." with that phrase in bold. The survey JSON carries the
// capitalised wording (so the GL Application and Quote Summary PDFs, which
// HTML-escape the attestation text, pick it up unchanged) and the bold is
// applied here at render time, for this one question only. survey-core renders
// a choice's text as plain text unless an onTextMarkdown handler supplies
// `html`, so every other string on the form keeps its default rendering.
export const ATTESTATIONS_QUESTION_NAME =
  'Munich_PersonalServices_9219_Attestations_WORLD_EN';

export const EMPHASIZED_ATTESTATION_PHRASE = 'AS REQUIRED';

const escapeHtml = (text: string): string =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

/**
 * HTML for an attestation choice text with the emphasized phrase wrapped in
 * <b>, or undefined when the text does not contain the phrase so SurveyJS
 * keeps its default plain-text rendering.
 */
export const emphasizeAttestationPhrase = (
  text: string
): string | undefined => {
  if (!text.includes(EMPHASIZED_ATTESTATION_PHRASE)) {
    return undefined;
  }
  return escapeHtml(text)
    .split(EMPHASIZED_ATTESTATION_PHRASE)
    .join(`<b>${EMPHASIZED_ATTESTATION_PHRASE}</b>`);
};

// Shape of the options survey-core passes to onTextMarkdown (typed as `any`
// upstream): `name` is the localizable string being rendered ('text' for a
// choice, 'title' for the question title) and `element` the owning question.
interface TextMarkdownOptions {
  element: { name: string };
  name: string;
  text: string;
  html: string | null;
}

const registerAttestationTextMarkdown = (model: Model): void => {
  model.onTextMarkdown.add(
    (_sender: SurveyModel, options: TextMarkdownOptions) => {
      if (
        options.name !== 'text' ||
        options.element.name !== ATTESTATIONS_QUESTION_NAME
      ) {
        return;
      }
      const html = emphasizeAttestationPhrase(options.text);
      if (html) {
        options.html = html;
      }
    }
  );
};

export default registerAttestationTextMarkdown;
